"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const spacing = {
    compact: {
        none: 0,
        xxs: 4,
        xs: 8,
        s: 12,
        m: 16,
        l: 24,
        xl: 32,
        xxl: 64,
    },
    regular: {
        none: 0,
        xxs: 4,
        xs: 8,
        s: 12,
        m: 24,
        l: 28,
        xl: 36,
        xxl: 72,
    },
    large: {
        none: 0,
        xxs: 4,
        xs: 8,
        s: 16,
        m: 24,
        l: 32,
        xl: 40,
        xxl: 80,
    },
};
exports.default = spacing;
//# sourceMappingURL=spacing.js.map